module.exports = __webpack_public_path__ + "img/Malaysia-3-hover.7d0ccadf.jpg";